import { useDataProvider } from 'react-admin';

import type { IngordDataProvider } from 'src/lib/types';

/**
 * Custom hook that provides data management functionality for Ingord components.
 *
 * This hook utilizes the base useDataProvider hook with specific typing for IngordDataProvider.
 *
 * @returns {IngordDataProvider} A data provider instance with Ingord-specific operations
 */
export const useIngordDataProvider = useDataProvider<IngordDataProvider>;
